module.exports = __webpack_public_path__ + "static/media/ngoHeaderOverlayMob.8aef49cc.svg";